import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    templateUrl: './invalid-url.component.html',
    standalone: false
})
export class InvalidUrlComponent implements OnInit {

  previouslyRequestedUrl: string;

  constructor(
    private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.previouslyRequestedUrl = this.route.snapshot.queryParams['previouslyRequestedUrl'];
  }

}
